import React from 'react';
import { SVGProps } from '@dreamai/types';

/**
 * SVG Component for rendering SVG content
 * Uses dangerouslySetInnerHTML to render the SVG string
 */
export const SVGComponent: React.FC<SVGProps> = ({
  dangerouslySetInnerHTML,
  width,
  height,
  viewBox,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      {...rest}
    />
  );
};

export default SVGComponent;
